import React from 'react';
import type { LinkProps as NextLinkProps } from 'next/link';
import { Link, PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';
import { IconCarretRight } from '@src/assets/icon-carret-right';

interface ShowAllTitleProps extends PropsWithClassProps<'title'> {
  title: string;
  linkText?: string;
  link: NextLinkProps['href'];
  onClick?: () => void;
  newTab?: boolean;
}

export const ShowAllTitle = ({
  title,
  linkText = 'Alle ansehen',
  link,
  onClick,
  newTab,
  classProps,
}: ShowAllTitleProps) => {
  if (!title || title === '') return null;
  return (
    <Link
      noLink={!link}
      href={link}
      onClick={() => {
        onClick?.();
      }}
      target={newTab ? '_blank' : '_self'}
      classProps={{ root: classProps?.root }}
    >
      <div
        className={twMerge(
          'relative z-10 mb-3 flex items-center overflow-hidden font-herokid text-xl font-bold text-foreground',
          !!link && 'group cursor-pointer',
          classProps?.title,
        )}
      >
        {title}
        {!!link && (
          <div className="relative ml-1 inline-grid h-full grid-cols-[0fr,auto] place-content-start items-center overflow-hidden whitespace-nowrap text-left text-2xs uppercase tracking-widest transition-all duration-300 group-hover:grid-cols-[1fr,auto] group-hover:text-primary">
            <div className="grid justify-end overflow-hidden pl-0 transition-all duration-300 group-hover:pl-1">
              {linkText}
            </div>
            <IconCarretRight />
          </div>
        )}
      </div>
    </Link>
  );
};
